import React, { useState } from "react";
import { Button, Input, Row, Select } from "antd";
import { ColStyled, Check, Close, Delete, Edit } from "./styled";
import { SearchQuery } from "PriceMonitoring/modal";
import { Space } from "shared/ui";
import {
  createSearchQuery,
  editSearchQuery,
  deleteSearchQuery,
} from "api/PriceMonitoring";
import { confirmPopup } from "shared/ConfirmPopup";

const marketplaceOptions = [
  { label: "Wildberries", value: "wb" as const },
  { label: "Ozon", value: "ozon" as const },
];

const SearchQueryListItem = (props: {
  data: SearchQuery;
  even: boolean;
  onUpdate: (updated: SearchQuery) => void;
  onDelete: (id: number) => void;
}) => {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(props.data.text);
  const [marketplace, setMarketplace] = useState(props.data.marketplace);

  const handleSave = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    const updated = await editSearchQuery(props.data.id, {
      text: trimmed,
      marketplace,
    });
    props.onUpdate(updated);
    setEditing(false);
  };

  const handleCancel = () => {
    setText(props.data.text);
    setMarketplace(props.data.marketplace);
    setEditing(false);
  };

  const handleDelete = async () => {
    const result = await confirmPopup(
      <>Уверены, что хотите удалить поисковый запрос?</>
    );
    if (result) {
      props.onDelete(props.data.id);
    }
  };

  return (
    <Row
      gutter={[16, 16]}
      style={{ background: props.even ? "rgba(0,0,0,0.05)" : "" }}
    >
      <ColStyled span={12}>
        {editing ? (
          <Input
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        ) : (
          props.data.text
        )}
      </ColStyled>
      <ColStyled span={6}>
        {editing ? (
          <Select
            value={marketplace}
            onChange={setMarketplace}
            options={marketplaceOptions}
            style={{ width: "100%" }}
          />
        ) : (
          marketplaceOptions.find((o) => o.value === props.data.marketplace)
            ?.label || props.data.marketplace
        )}
      </ColStyled>
      <ColStyled span={6}>
        {editing ? (
          <>
            <Check onClick={handleSave} />
            <Space size={8} inline />
            <Close onClick={handleCancel} />
          </>
        ) : (
          <>
            <Edit onClick={() => setEditing(true)} />
            <Space size={8} inline />
            <Delete onClick={handleDelete} />
          </>
        )}
      </ColStyled>
    </Row>
  );
};

const SearchQueryList = (props: {
  data: SearchQuery[];
  groupId: number;
  onChange: (queries: SearchQuery[]) => void;
}) => {
  const [adding, setAdding] = useState(false);
  const [newText, setNewText] = useState("");
  const [newMarketplace, setNewMarketplace] = useState<"wb" | "ozon">("wb");

  const handleAdd = async () => {
    const trimmed = newText.trim();
    if (!trimmed) return;
    const created = await createSearchQuery({
      text: trimmed,
      marketplace: newMarketplace,
      groups: [{ id: props.groupId }],
    });
    props.onChange([...props.data, created]);
    setNewText("");
    setNewMarketplace("wb");
    setAdding(false);
  };

  const handleUpdate = (updated: SearchQuery) => {
    props.onChange(
      props.data.map((q) => (q.id === updated.id ? updated : q))
    );
  };

  const handleDelete = async (id: number) => {
    await deleteSearchQuery(id);
    props.onChange(props.data.filter((q) => q.id !== id));
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <ColStyled span={12}>
          <strong>Запрос</strong>
        </ColStyled>
        <ColStyled span={6}>
          <strong>Маркетплейс</strong>
        </ColStyled>
        <ColStyled span={6}></ColStyled>
      </Row>
      {props.data.map((query, i) => (
        <SearchQueryListItem
          key={query.id}
          data={query}
          even={i % 2 === 0}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
        />
      ))}
      {adding && (
        <Row gutter={[16, 16]}>
          <ColStyled span={12}>
            <Input
              value={newText}
              onChange={(e) => setNewText(e.target.value)}
              placeholder="Текст запроса"
            />
          </ColStyled>
          <ColStyled span={6}>
            <Select
              value={newMarketplace}
              onChange={setNewMarketplace}
              options={marketplaceOptions}
              style={{ width: "100%" }}
            />
          </ColStyled>
          <ColStyled span={6}>
            <Check onClick={handleAdd} />
            <Space size={8} inline />
            <Close
              onClick={() => {
                setAdding(false);
                setNewText("");
                setNewMarketplace("wb");
              }}
            />
          </ColStyled>
        </Row>
      )}
      {!adding && (
        <Row style={{ marginTop: 8 }}>
          <Button onClick={() => setAdding(true)}>Добавить запрос</Button>
        </Row>
      )}
    </>
  );
};

export default SearchQueryList;
